module.exports = __webpack_public_path__ + "img/circle-false.a8b5b68e.svg";